import { Controller } from '@hotwired/stimulus';
import { formatPriceForSelectedCurrency } from '../bundles/utilities/pricing';

export default class extends Controller {
  static values = {
    amount: Number,
  };

  connect() {
    this.update();
  }

  update() {
    this.element.textContent = formatPriceForSelectedCurrency(this.amountValue);
  }
}
